@if (compact()) {
  <div class="border-b border-border bg-white px-8 py-4">
    <button
      type="button"
      data-test="hub-tabs-collapsed"
      [attr.aria-expanded]="menuOpen()"
      class="flex h-16 w-full cursor-pointer items-center gap-2 rounded-full pl-4 pr-6 text-variant-sm text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      [class]="menuOpen() ? 'bg-blue-700' : 'bg-blue-600 hover:bg-blue-700'"
      stchPopover
      stchPopoverTrigger="click"
      stchPopoverPlacement="bottomFullWidth"
      [stchPopoverTemplate]="collapsedMenu"
      [stchPopoverShowUntil]="menuClose"
      (stchPopoverVisibleChange)="menuOpen.set($event)"
    >
      <app-icon [name]="activeItem().icon" [size]="20" />
      <span class="min-w-0 flex-1 truncate text-left">{{ activeItem().label }}</span>
      <span
        class="flex h-8 min-w-8 items-center justify-center rounded-full bg-white px-2 text-variant-sm-medium text-blue-600"
        >{{ activeItem().countLabel }}</span
      >
      <app-icon data-test="hub-tabs-chevron" name="sapphire-chevron-down" [size]="16" />
    </button>
  </div>

  <ng-template #collapsedMenu>
    <div class="flex flex-col gap-1 p-4">
      @for (tab of items(); track tab.type) {
        <button
          type="button"
          data-test="hub-tabs-menu-item"
          [attr.aria-current]="tab.isActive"
          class="flex h-20 cursor-pointer items-center gap-4 rounded-lg px-4 text-left text-variant-md focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-blue-600"
          [class]="tab.isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-950 hover:bg-gray-100'"
          (click)="handleMenuSelect(tab.type)"
        >
          <app-icon [name]="tab.icon" [size]="20" />
          <span class="min-w-0 flex-1 truncate">{{ tab.label }}</span>
          <span class="shrink-0 text-variant-md text-gray-950">{{ tab.countLabel }}</span>
        </button>
      }
    </div>
  </ng-template>
} @else {
  <nav class="flex w-full flex-wrap items-center gap-4 border-b border-border bg-white px-8 py-4">
    @for (tab of items(); track tab.type) {
      <button
        type="button"
        data-test="hub-tab"
        class="flex h-16 shrink-0 cursor-pointer items-center gap-2 rounded-full border px-4 text-variant-sm transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
        [class]="
          tab.isActive
            ? 'border-blue-600 bg-blue-600 text-white'
            : 'border-border bg-white text-gray-950 hover:bg-gray-100'
        "
        [attr.aria-pressed]="tab.isActive"
        (click)="handleSelect(tab.type)"
      >
        <app-icon [name]="tab.icon" [size]="20" />
        <span class="whitespace-nowrap" data-test="hub-tab-label">{{ tab.label }}</span>
        <span
          class="flex h-8 min-w-8 items-center justify-center rounded-full px-2 text-variant-sm-medium"
          data-test="hub-tab-count"
          [class]="
            tab.isActive ? 'bg-white text-blue-600' : tab.count > 0 ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
          "
          >{{ tab.countLabel }}</span
        >
      </button>
    }
  </nav>
}
